var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-container"},[_c('button',{class:['info-button', {'animate-button': _vm.isAnimated}],attrs:{"tabindex":-1,"disabled":_vm.disabled},on:{"click":[_vm.handleClick,function($event){$event.stopPropagation();$event.preventDefault();}]}},[_c('i',{class:['fa-xs', _vm.icon]})])])
}
var staticRenderFns = []

export { render, staticRenderFns }